(function (app) {
  $(document).ready(function () {

    app.InsightImages = function () {

      var _this = this;

      var nameSpace = 'InsightImages',
        context = '.page__insight-images--container'
        ;

      /**
       *
       * @param url
       * @param callback
       * @returns {*}
       */
      _this.get = function (url, callback) {
        var query = $.Deferred();
        var appTransport = app.transport();

        appTransport
          .setEvent('onSuccess', function (response) {
            callback(response);
            return query.resolve(response);
          })
          .setEvent('onError', function (error) {
            app.flashMessenger('error', error.code + ' :: ' + error.message.message);
            return query.reject(error);
          })
          .setEvent('onComplete', function () {

          })
        ;
        appTransport.get(url);
        return query.promise();
      };


      _this.getUrl = function (url, category) {
        if (_.isUndefined(category)) {
          return url;
        } else {
          return url + '?' + 'category=' + category;
        }

      };

      /**
       * Get Emotional Tones
       */
      _this.getEmotionalTones = function (category) {
        var $dataBody = $('.images-emotional-tones__body', $(context));
        $dataBody.html('');
        $dataBody.addClass('m-progress');
        _this.get(_this.getUrl('/api/insight/images-emotional-tones', category), function (response) {
          $dataBody.removeClass('m-progress');
          var dataRow = _.template(app.templates["Insight__images____emotional-tones"]);
          var $dataRow = $(
            dataRow(
              $.extend(response, {})
            )
          );
          $dataRow.appendTo($dataBody);

          if (_.isEmpty(response['yours'])) {
            dataRow = _.template(app.templates["Insight__text____no-records"]);
            $dataRow = $(
              dataRow(
              )
            );
            $dataRow.appendTo($dataBody.find('.yours-data'));
          }
        })
      };

      /**
       * Get Image Colors
       */
      _this.getImageColors = function (category) {
        var $dataBody = $('.images-colors__body', $(context));
        $dataBody.html('');
        $dataBody.addClass('m-progress');
        _this.get(_this.getUrl('/api/insight/images-colors', category), function (response) {
          $dataBody.removeClass('m-progress');
          var dataRow = _.template(app.templates["Insight__images____colors"]);
          var $dataRow = $(
            dataRow(
              $.extend(response, {})
            )
          );
          $dataRow.appendTo($dataBody);
        })
      };

      /**
       *
       */
      _this.getEngagements = function (category) {
        var $dataBodyYours = $('.images-engagement-yours__body', $(context));
        var $dataBodyall = $('.images-engagement-all-users__body', $(context));
        $dataBodyYours.html('');
        $dataBodyall.html('');
        $dataBodyYours.addClass('m-progress');
        $dataBodyall.addClass('m-progress');
        _this.get(_this.getUrl('/api/insight/images-engagement', category), function (response) {
          $dataBodyYours.removeClass('m-progress');
          $dataBodyall.removeClass('m-progress');

          var dataRow = _.template(app.templates["Insight__images____engagement"]);
          var $dataRow = $(
            dataRow(
              {'rows': response['yours']}
            )
          );

          $dataRow.appendTo($dataBodyYours);

          $dataRow = $(
            dataRow(
              {'rows': response['all']}
            )
          );
          $dataRow.appendTo($dataBodyall);

          if (_.isEmpty(response['yours'])) {
            dataRow = _.template('<div class="text-center text-danger" > No images are available. </div>');
            $dataRow = $(
              dataRow(
              )
            );
            $dataRow.appendTo($dataBodyYours);
          }

          app.lazyLoadImage($dataBodyYours);
          app.lazyLoadImage($dataBodyall);
        })
      };

      _this.lastUpdatedToUserTimezone = function() {
        var $lastUpdated = $('[data-last-updated]');
        var lastUpdated = $lastUpdated.attr('data-last-updated');
        lastUpdated = app.utcToUserTimezone(lastUpdated);
        $lastUpdated.text(lastUpdated);
      };

      return {
        init: function () {
          _this.lastUpdatedToUserTimezone();

          if ($('[data-modal-image-manager-full-image]').length == 0) {
            _this.fullImageModal = $(app.templates["Image__manager____modal-full-image"]);
            $('body').append(_this.fullImageModal);
          }

          _this.fullImageModal = $('[data-modal-image-manager-full-image]');

          _this.getEmotionalTones();
          _this.getImageColors();

          _this.getEngagements();

          $(document).off('change.search__' + nameSpace).on('change.search__' + nameSpace, context + ' select[name=category]', function (e) {

            var category = $(this).val();
            _this.getEmotionalTones(category);
            _this.getImageColors(category);

            _this.getEngagements(category);

          }).off('click.actions__' + nameSpace).on('click.actions__' + nameSpace, context + ' [data-action]', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var action = $(this).attr('data-action');

            switch (action) {
              case 'preview' :
                var thumbnail = $(this).attr('src');
                var image = $(this).attr('data-url');
                var $imageRow = $(
                  '<div class="post__image ">' +
                  '<img src="' + thumbnail + '" data-src="' + image + '"  class="lazy img-fluid">' +
                  '</div>'
                );
                var $modalBody = _this.fullImageModal.find('.modal-body');
                $modalBody.html('');
                $imageRow.appendTo($modalBody);
                _this.fullImageModal.modal('show');
                app.lazyLoadImage(_this.fullImageModal);
                break;
            }

          });

        }
      };
    };
  });
})(PreBuilt);

